import { render, staticRenderFns } from "./tabProfil.vue?vue&type=template&id=652f0057&scoped=true"
import script from "./tabProfil.vue?vue&type=script&lang=js"
export * from "./tabProfil.vue?vue&type=script&lang=js"
import style0 from "./tabProfil.vue?vue&type=style&index=0&id=652f0057&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652f0057",
  null
  
)

export default component.exports